import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../theme';

const { colors, fonts, fontSize, spacing, radius } = redesignTheme;

export const useChoiceOptionStyles = makeStyles(() => ({
  choiceOption: {
    width: '100%',
    minHeight: 70,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: spacing.sm,
    border: '1px solid #d9d9d9',
    borderRadius: radius.sm,
    backgroundColor: colors.white,
    cursor: 'pointer',
    textAlign: 'left',
    boxSizing: 'border-box',
    color: colors.text,
  },
  choiceOptionDisabled: {
    cursor: 'default',
  },
  choiceOptionSelected: {
    borderColor: colors.primary,
    backgroundColor: 'rgba(0, 10, 141, 0.04)',
  },
  choiceRadio: {
    width: 14,
    height: 14,
    borderRadius: '50%',
    border: '1px solid #d9d9d9',
    backgroundColor: colors.white,
    boxSizing: 'border-box',
    flexShrink: 0,
  },
  choiceRadioSelected: {
    border: 0,
    background: `radial-gradient(circle, ${colors.primary} 0 4px, ${colors.white} 4px 5px, ${colors.primary} 5px 7px)`,
  },
  choiceOptionLabel: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.text,
    lineHeight: 'normal',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  choiceOptionLabelSelected: {
    fontFamily: fonts.opensansBold,
    color: colors.primary,
  },
  choiceOptionText: {
    flex: 1,
    minWidth: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.text,
    lineHeight: 'normal',
    '& p, & h3': {
      margin: 0,
      lineHeight: 1.2,
    },
  },
}));
